import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {
  Navigation,
  TargetType,
} from '../../../../../dto/response/template.config';
import { NavigationService } from '../../../../../service/navigation.service';

@Component({
  selector: 'app-footer-links',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer-links.component.html',
  styleUrl: './footer-links.component.scss',
})
export class FooterLinksComponent {
  PDP = TargetType.PDP;
  PLP = TargetType.PLP;
  EXTERNAL_PAGE = TargetType.EXTERNAL_PAGE;
  INTERNAL_PAGE = TargetType.INTERNAL_PAGE;
  PROMOS = TargetType.PROMOS;

  @Input()
  navigation: Navigation[];

  constructor(
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  goTo(nav: Navigation) {
    this.navigationService.navigateTo(nav);
  }
}
